import {GeneralSpecification} from "../../../../../MainMenu/Panels/SpecificationPanel/utils";
import {ItemI} from "../../../../../../shared";
import {Content} from "pdfmake/interfaces";
import {GetItemReturnArr} from "../../../../../MainMenu/Panels/SpecificationPanel/SpecificationGeneral";
import {defPDFHeader} from "../../../../partsOfPage";
import {formatDate, primaryColor} from "../../../../consts";
import {getPrimarySpecificationTableHeader} from "./getPrimarySpecificationTableHeader";
import {getPrimarySpecificationTableBodyOneRow} from "./getPrimarySpecificationTableBodyOneRow";


//Отступы для общей таблицы (слева/справа)
export const SIDE_MARGINS = 200

export const getJSONForGeneralSpecification = (generalSpecification: GeneralSpecification, parts: ItemI[]): Content => {
    //Доступное количество строк (вычислено эмпирически)
    const availableCountRows = 27
    let currentRow = 1
    const json: Content = []
    const allSpecificationElements: GetItemReturnArr[] = []
    Object.values(generalSpecification).forEach((elements: GetItemReturnArr[]) => elements.forEach(element => allSpecificationElements.push(element)))
    allSpecificationElements.forEach((item, index, itemsArr) => {
        const isLastRowInSection = itemsArr.length - 1 === index
        if (currentRow === 1) {
            json.push({
                color: primaryColor,
                text: `Спецификация от ${formatDate}`,
                fontSize: 16,
                bold: true,
                margin: [20, 17, 0, 0],
            });
            json.push(getPrimarySpecificationTableHeader())
        }
        if (index === 0) {
            json.push(getPrimarySpecificationTableBodyOneRow(item))
            currentRow++
        } else {
            currentRow++
            if (currentRow === availableCountRows) {
                json.push(getPrimarySpecificationTableBodyOneRow(
                    item,
                    isLastRowInSection,
                    true
                ))
            } else {
                json.push(getPrimarySpecificationTableBodyOneRow(item, isLastRowInSection))
            }
        }
        if (currentRow === availableCountRows) {
            currentRow = 1
        }
    })
    if (availableCountRows - currentRow < 5) {
        json.push({text: '', pageBreak: 'after'})
        json.push(JSON.parse(JSON.stringify(defPDFHeader)))
    }
    return json;
}
